const urlEntrys = {
  system: [
    '/_nuxt/',
    '/components/',
    '/_loading/',
    '/pages/',
    '/layouts/',
    '/__webpack_hmr/',
  ],
  bff: [process.env.SM_API_ROOT],
}

const checkUrl = (type: keyof typeof urlEntrys, url: string) => {
  for (const entry of urlEntrys[type]) {
    if (url.includes(entry)) {
      return true
    }
  }
  return false
}

export function isSystemRequestUrl(url: string) {
  return checkUrl('system', url)
}

export function isBffRequestUrl(url: string) {
  return checkUrl('bff', url)
}
